export { PlacardImageCarousel } from './placard-image-carousel.esm.js';
//# sourceMappingURL=index.esm.js.map
